import React from "react";
import { FaShare } from "react-icons/fa";

interface ShareButtonProps {
  url: string;
  title: string;
  description?: string;
  className?: string;
}

/**
 * ShareButton component that allows sharing via Web Share API or native share
 * Falls back to copying link to clipboard if Web Share API is not available
 */
export const ShareButton: React.FC<ShareButtonProps> = ({
  url,
  title,
  description,
  className = "",
}) => {
  const handleShare = async (): Promise<void> => {
    // Check if Web Share API is supported
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text: description,
          url,
        });
      } catch (error: any) {
        // User cancelled or error occurred - ignore
        if (error.name !== "AbortError") {
          console.error("Error sharing:", error);
        }
      }
    } else {
      // Fallback: Copy to clipboard
      try {
        await navigator.clipboard.writeText(url);
        // Show a brief notification (you might want to use a toast here)
        alert("Link copied to clipboard!");
      } catch (error) {
        console.error("Error copying to clipboard:", error);
        // Final fallback: show URL in prompt
        prompt("Copy this link:", url);
      }
    }
  };

  return (
    <button
      onClick={handleShare}
      className={`inline-flex items-center justify-center p-2 text-store-primary-light hover:text-store-primary hover:bg-store-background rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-store-secondary focus:ring-offset-2 ${className}`}
      aria-label="Share"
    >
      <FaShare className="w-4 h-4" />
    </button>
  );
};
